'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_Keyword(id_$_lo, id_$_hi, name, accountId_$_lo, accountId_$_hi) {
  this.Vx = 0;
  this.Vy = 0;
  this.Sn = null;
  this.Vv = 0;
  this.Vw = 0;
  this.Vx = id_$_lo;
  this.Vy = id_$_hi;
  this.Sn = name;
  this.Vv = accountId_$_lo;
  this.Vw = accountId_$_hi;
}
export { $c_Lmealorama_Keyword as $c_Lmealorama_Keyword };
$p = $c_Lmealorama_Keyword.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_Keyword;
/** @constructor */
function $h_Lmealorama_Keyword() {
}
export { $h_Lmealorama_Keyword as $h_Lmealorama_Keyword };
$h_Lmealorama_Keyword.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-516226962), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_Keyword)) {
    var x_$_lo = this.Vx;
    var x_$_hi = this.Vy;
    var $x_1 = x$0;
    var x$1_$_lo = $x_1.Vx;
    var x$1_$_hi = $x_1.Vy;
    if (((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0) && (this.Sn === x$0.Sn))) {
      var x$2_$_lo = this.Vv;
      var x$2_$_hi = this.Vw;
      var $x_2 = x$0;
      var x$3_$_lo = $x_2.Vv;
      var x$3_$_hi = $x_2.Vw;
      return (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 3;
});
$p.r = (function() {
  return "Keyword";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.Vx, this.Vy);
      break;
    }
    case 1: {
      return this.Sn;
      break;
    }
    case 2: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.Vv, this.Vw);
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_Keyword(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jF)));
}
export { $isArrayOf_Lmealorama_Keyword as $isArrayOf_Lmealorama_Keyword };
var $d_Lmealorama_Keyword = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_Keyword, "mealorama.Keyword", ({
  jF: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_Keyword as $d_Lmealorama_Keyword };
//# sourceMappingURL=mealorama.-Keyword.js.map
